package br.com.htms.inspeccaocampo.shared.ui.components

import br.com.htms.inspeccaocampo.ui.kit.LinhaOpcoes
import br.com.htms.inspeccaocampo.ui.theme.PortalCores
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.MaterialTheme
import br.com.htms.inspeccaocampo.shared.ui.components.AppOutlinedTextField
import androidx.compose.material3.RadioButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.semantics.Role
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.data.FotoAnexo
import br.com.htms.inspeccaocampo.data.ItemVerificacao
import br.com.htms.inspeccaocampo.data.RespostaTernaria

@Composable
fun ItemVerificacaoCard(
    item: ItemVerificacao,
    erro: String?,
    onResposta: (RespostaTernaria) -> Unit,
    onJustificativa: (String) -> Unit,
    onTirarFoto: () -> Unit,
    onAdicionarMaisFoto: () -> Unit,
    onRemoverFoto: (FotoAnexo) -> Unit,
    onGaleria: (() -> Unit)? = null,
    modifier: Modifier = Modifier
) {
    var mostrarLista by remember { mutableStateOf(false) }

    Card(
        modifier = modifier.fillMaxWidth(),
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface), border = PortalCores.BordaCartao
    ) {
        Column(Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
            Text(item.titulo, fontWeight = FontWeight.SemiBold, color = PortalCores.Navy)
            LinhaOpcoes(
                opcoes = RespostaTernaria.entries,
                selecionada = item.resposta,
                rotulo = { it.rotulo },
                cor = ::corTernaria,
                onSelect = onResposta
            )
            when (item.resposta) {
                RespostaTernaria.SIM -> {
                    CampoFotoRow(
                        label = "Foto",
                        obrigatorio = item.fotoObrigatoriaSeSim,
                        quantidadeFotos = item.fotos.size,
                        onTirarFoto = onTirarFoto,
                        onAdicionarMais = onAdicionarMaisFoto,
                        onAbrirLista = { mostrarLista = true },
                        onGaleria = onGaleria
                    )
                }
                RespostaTernaria.NAO -> {
                    AppOutlinedTextField(
                        value = item.justificativa,
                        onValueChange = onJustificativa,
                        label = { Text("Justificativa *") },
                        modifier = Modifier.fillMaxWidth(),
                        minLines = 2,
                        colors = FormFieldDefaults.textFieldColors(),
                        isError = erro != null
                    )
                    CampoFotoRow(
                        label = "Foto",
                        obrigatorio = item.fotoObrigatoriaSeNao,
                        quantidadeFotos = item.fotos.size,
                        onTirarFoto = onTirarFoto,
                        onAdicionarMais = onAdicionarMaisFoto,
                        onAbrirLista = { mostrarLista = true },
                        onGaleria = onGaleria
                    )
                }
                RespostaTernaria.NA -> {
                    AppOutlinedTextField(
                        value = item.justificativa,
                        onValueChange = onJustificativa,
                        label = { Text("Justificativa *") },
                        modifier = Modifier.fillMaxWidth(),
                        minLines = 2,
                        colors = FormFieldDefaults.textFieldColors(),
                        isError = erro != null
                    )
                }
                null -> Unit
            }
            erro?.let {
                Text(it, color = MaterialTheme.colorScheme.error, style = MaterialTheme.typography.bodySmall)
            }
        }
    }

    if (mostrarLista) {
        SharedFotosMenu(
            titulo = item.titulo,
            fotos = item.fotos,
            aberto = true,
            onFechar = { mostrarLista = false },
            onRemover = onRemoverFoto
        )
    }
}

fun corTernaria(r: RespostaTernaria) = when (r) {
    RespostaTernaria.SIM -> PortalCores.Verde
    RespostaTernaria.NAO -> PortalCores.Vermelho
    RespostaTernaria.NA -> PortalCores.CinzaTexto
}
